import { useRemoveProjectLabel } from 'src/service/project';
import { createConfig } from 'src/utils/create-config';
import { useDeleteCollection } from './hooks';

const CONFIG_LABEL = {
  REPPL: {
    /** label can be feature (NOT label's collection item) */
    canFeature: true,
    route: {
      key: 'collections',
      detail: '/reppl/[rid]/collections/[cid]',
    },
    collectionDelete: (isCollectionOwner?: boolean) => ({
      title: 'Remove this collection from the RE:PPL?',
      text: `This action cannot be undone. The collection will still be visible in ${
        isCollectionOwner ? 'your' : "the owner's"
      } Studio. Existing episodes will remain in the RE:PPL.`,
      hook: useRemoveProjectLabel,
      okBtnText: 'Remove',
    }),
    text: {
      deleteCollection: 'Remove this collection from the RE:PPL',
      empty: 'No collections yet.',
    },
  },
  STUDIO: {
    canFeature: false,
    route: {
      key: 'collections',
      detail: '/[username]/collections/[cid]',
    },
    collectionDelete: () => ({
      title: 'Delete this collection',
      text:
        'This action cannot be undone. This won’t impact posts in the collection.',
      hook: useDeleteCollection,
      okBtnText: 'Delete',
    }),
    text: {
      deleteCollection: 'Delete this collection',
      empty: 'No collections yet.',
    },
  },
} as const;

export const labelConfig = createConfig(CONFIG_LABEL, {
  alias: {
    EPISODE: 'REPPL',
  },
  defaultKey: 'REPPL',
});
